import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { PawnDataService } from 'src/providers/pawn-data/pawn-data.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfigService } from 'src/providers/config/config.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { ConfirmPagosPage } from '../confirm-pagos/confirm-pagos.page';

@Component({
  selector: 'factura',
  templateUrl: './factura.page.html',
  styleUrls: ['./factura.page.scss'],
})
export class FacturaPage implements OnInit {
  factura: any;
  detalles: any;
  voy_a_pagar = 0;

  urlBancard = '';
  urlSafe: SafeResourceUrl;
  iframeLoad = 0;
  process_id = 0;

  constructor(
    public navCtrl: NavController,
    private navParams: NavParams,
    private pawnServ: PawnDataService,
    private modalCtrl: ModalController,
    private domsanitizer: DomSanitizer,
    private config: ConfigService,
    private shared: SharedDataService
  ) {
    this.factura = navParams.get('factura');


    this.abrirDetalle();
  }


  abrirDetalle() {

    this.pawnServ.detalles(this.factura.id)
      .subscribe(
        (data) => { // Success
          if (data['estado'] > 0) this.detalles = data['detalles'];
        },
        (error) => {
          console.log(error);
        }
      )
  }

  dimiss() {
    this.modalCtrl.dismiss();
  }


  ngOnInit() {
    this.urlBancard = '';
  }


  pagar() {


    // generar un process_id para validacion bancard
    let dat = { id: 0 };

    this.config.post_Http('getprocessid', dat)
      .subscribe(
        (data) => { // Success        
          this.process_id = data['process_id'];
          this.showFrameBancard();
        },
        (error) => {
          console.log(error);
        });

  }

  showFrameBancard() {

    this.urlBancard =  this.config.yourSiteUrl + '/bancard/checkout.php?amount=' + this.factura.importe + '&proccess_id=' + this.process_id;
    console.log(this.urlBancard)
    this.urlSafe = this.domsanitizer.bypassSecurityTrustResourceUrl(this.urlBancard);
    this.iframeLoad = 0;

    this.voy_a_pagar = 1;

  }

  onLoadIframe() {

    this.iframeLoad++;
    if (this.iframeLoad == 2) {
      this.config.post_Http_bancard('/bancard/get_proccess.php?proccess_id=' + this.process_id + '&json')
        .subscribe(
          (data) => { // Success        

            if (data['confirmation']['response_code'] == '00') {
              this.shared.confirmationBancard = data['confirmation'];
              this.addPayment(data);

            } else {
              // mostrar pantalla de error
              this.shared.confirmationBancard = data['confirmation'];

              this.showResultado()
            }

          },
          (error) => {
            console.log(error);
          });

    }
  }

  addPayment(data) {

     /* registrar en la db CasaRosada */
     
    let campos = {
      process_id: this.process_id, idcedula: this.shared.customerData.document, idempeno: this.factura.idempeno, nroboleta: this.factura.nroboleta, vencimiento: this.factura.vencimiento,
      importe: this.factura.importe, descripcion: this.factura.descripcion, importe_retiro: this.factura.importe_retiro, id: this.factura.id, order_information: data['confirmation']
    };
    let dat = { campos: campos };
    this.config.post_Http('registerpaypawn', dat)
      .subscribe(
        (data) => { // Success        
          if (data['estado'] == 'ok') {
            this.urlBancard = '';
            this.voy_a_pagar = 0;

            // Generar recibo de pago en la db principal...
            

            // mostrar pagina de resultado...
            this.showResultado();
          }
        },
        (error) => {

          console.error(error);
        });


  }

  async showResultado() {
    let modal = await this.modalCtrl.create({
      component: ConfirmPagosPage
    });
    return await modal.present();
  }

}
